// import 'inputmask/dist/jquery.inputmask.bundle.js';
import Cookies from '@components/cookies/scripts.js';
import $ from 'jquery';
import moment from 'moment';
// import '@components/animations/scripts';

import '@components/header/scripts';
import '@components/modal/scripts';
import '@components/tooltip/scripts';
import '@components/slider/scripts';
import '@components/gallery/scripts';
import '@components/map/scripts';
import '@components/preloader/scripts';
import '@components/scroll-up/scripts';

import '@components/input/scripts';
import '@components/select/scripts';
import '@components/datepicker/scripts';
import '@components/calendar/scripts';
import '@components/calendar/calendar-events/scripts';
import '@components/calendar/calendar-table/scripts';
import '@components/schedule-picker/scripts';

// import '@components/socials/scripts';
import '@components/link/scripts';
import '@components/copy/scripts';
import '@components/like/scripts';
import '@components/labels/scripts';

import '@components/tabs/scripts';
import '@components/more/scripts';
import '@components/accordion/scripts';
import '@components/spoiler/scripts';
import '@components/filming-card/scripts';

import '@components/generator/scripts';
import '@components/observer/scripts';

import '@components/timepicker/scripts';

import '@components/check-validation/index';

import scheduleCalendar from '@components/schedule-calendar/index.js';
import '@components/event-application/index.js';

import registerFormValidator from '@components/formValidator/init.js';
import validatorServices from '@components/validator/services.js';
import notify from '@components/notification/index.js';
import { inputTypeTime } from '@components/input/index.js';
import { initSelect } from '@components/select/index.js';

window.datepickerChange = function (el) {
  // console.log(el);
};

moment.updateLocale('ru', {});

const init = () => {
  global.spiks = {};
  global.spiks.notify = notify;
  global.spiks.validator = validatorServices;
  global.spiks.inputTypeTime = inputTypeTime;
  global.spiks.initSelect = initSelect;
  global.spiks.scheduleCalendar = scheduleCalendar;
  global.spiks.datepickerChange = window.datepickerChange;
  global.spiks.Calendar = window.Calendar;
  global.spiks.CalendarEvents = window.CalendarEvents;
  global.spiks.CalendarTable = window.CalendarTable;
  global.moment = moment();

  new Cookies();
  registerFormValidator();

  // global.$ = $;
};

export default init;
